import { motion } from "framer-motion";
import { Handshake, Wrench, ArrowRight, Scale, Megaphone, Users, FlaskConical, TrendingUp } from "lucide-react";

const practices = [
  { icon: Scale, name: "Lobbying" },
  { icon: Megaphone, name: "Strategic Communication" },
  { icon: Users, name: "Advocacy" },
  { icon: FlaskConical, name: "Research" },
  { icon: TrendingUp, name: "Economic Development" },
];

const HomeBottomCtas = () => {
  return (
    <section className="bg-cream py-12 md:py-20">
      <div className="container mx-auto px-4 md:px-6 grid md:grid-cols-2 gap-4 md:gap-5">
        {/* Become a Partner */}
        <motion.a
          href="/partners"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="group block rounded-[var(--radius)] bg-card border border-border shadow-card p-5 md:p-8 flex flex-col"
        >
          <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary/10 flex items-center justify-center mb-4 md:mb-5">
            <Handshake className="h-4 w-4 md:h-5 md:w-5 text-primary" />
          </div>
          <div className="text-primary text-[11px] md:text-xs font-semibold tracking-[0.2em] uppercase mb-2">
            Become a Partner
          </div>
          <h3 className="font-display text-lg md:text-2xl font-bold text-foreground leading-tight mb-2 md:mb-3">
            Get promoted to the communities moving Alabama forward
          </h3>
          <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-5 md:mb-6 flex-1">
            Join our DBE-focused partner network. We'll surface your services to advocates, agencies, policymakers, and funders actively looking for community-rooted operators.
          </p>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
            Apply to partner
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </motion.a>

        {/* Use our tools */}
        <motion.a
          href="/services"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="group block rounded-[var(--radius)] bg-card border border-border shadow-card p-5 md:p-8 flex flex-col"
        >
          <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary/10 flex items-center justify-center mb-4 md:mb-5">
            <Wrench className="h-4 w-4 md:h-5 md:w-5 text-primary" />
          </div>
          <div className="text-primary text-[11px] md:text-xs font-semibold tracking-[0.2em] uppercase mb-2">
            Use Our Tools
          </div>
          <h3 className="font-display text-lg md:text-2xl font-bold text-foreground leading-tight mb-2 md:mb-3">
            Five practice areas, one toolkit to boost your reach
          </h3>
          <ul className="space-y-2 mb-5 md:mb-6 flex-1">
            {practices.map((p) => (
              <li key={p.name} className="flex items-center gap-3 text-sm text-foreground">
                <span className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <p.icon className="h-3 w-3 md:h-3.5 md:w-3.5 text-primary" />
                </span>
                {p.name}
              </li>
            ))}
          </ul>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
            Explore our practice
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </motion.a>
      </div>
    </section>
  );
};

export default HomeBottomCtas;